<template lang="pug">
v-app
  top-bar(style="position:fixed")
  v-content
      v-container.grid-area
          v-card.d-flex.module-item(
              v-for="(item, index) in modules"
              :key="item.id"
              @click='goToModule(item.url_module, item.id)'
              )
              v-img.mx-3(
                :src='item.absolute_bg_url_module'
                aspect-ratio='1'
                )
              v-card-title.text-xs-center(style="width: 100%")
                  h3.headline.mb-0.text-xs-center {{ item.name }} 
                  div.text-xs-center  {{ card_text }} 
  v-dialog(v-model="cashDeskTokenModal")
    v-toolbar.primary(dark)
      span.title Ingrese Token de Caja
    v-card.pa-4
      v-form(ref="token_form")
        v-text-field(
          label="token"
          v-model="cashDeskToken"
          outline
          ref="cash_desk_token"
          @keydown.enter="handleTokenInput($event)"
          )
      span.grey--text.text--darken-3.pl-2 Si no cuenta con un token 
        | contacte con el departamento de informática
</template>

<script>
import { mapActions } from 'vuex'
import TopBar from './TopBar.vue'
import { generateTemporalModuleTokenRequest } from '@/services/api/auth/AuthService'
import { modulesRequest } from '@/services/api/modules/ModulesService'
import { sortBy } from 'lodash'
export default {
    name: 'dashboard',
    data: () => {
        return {
            modules: [],
            CASH_MODULE_ID: 2,
            cashDeskTokenModal: false,
            cashDeskToken: '',
        }
    },
    components: {
        TopBar,
    },
    created: function() {
        modulesRequest()
            .then(response => {
                this.modules = sortBy(response.data.g_modules_user, 'id')
            })
            .catch(err => {
                this.modules = []
            })
    },
    mounted() {
        document.title = 'Menú Principal - Agroplastic'
    },
    methods: {
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            resetSnackbarState: 'resetSnackbarState',
        }),
        goToModule(url, idModule) {
            if (this.checkRightConditions_ForGoToModule(idModule))
                this.setParamsAndGenerateTemporalModuleTokenRequest(
                    url,
                    idModule
                )
            else this.cashDeskTokenModal = true
        },
        checkRightConditions_ForGoToModule(idModule) {
            return (
                this.checkDontGoToCashModule(idModule) ||
                this.checkGoToCashModuleWithToken(idModule)
            )
        },
        setParamsAndGenerateTemporalModuleTokenRequest(url, idModule) {
            let param = this.setParamGenerateTempModuleTokenRequest()
            generateTemporalModuleTokenRequest(param)
                .then(response => {
                    url = this.getModuleUrlWithParams(url, response, idModule)
                    this.goToUrl(url)
                })
                .catch(err => {
                    this.showSnackBarError('Hay problemas con el servidor')
                })
        },
        setParamGenerateTempModuleTokenRequest() {
            return {
                user_token: localStorage.getItem('user-token'),
            }
        },
        getModuleUrlWithParams(url, response, idModule) {
            url += this.getModuleToken(response)
            url += this.getCashDeskTokenIfNeeded(idModule)
            if (this.$route.query.tbk_url)
                url += `&tbk_url=${this.$route.query.tbk_url}`
            return url
        },
        getModuleToken(response) {
            return '?module_token=' + response.data.module_token
        },
        getCashDeskTokenIfNeeded(idModule) {
            return this.checkGoToCashModuleWithToken(idModule)
                ? '&cash_desk_token=' + this.getCashDeskToken()
                : '' // void string
        },
        goToUrl(url) {
            window.location = url
        },
        getCashDeskToken() {
            //return window.location.search.substr(1).split('=')[1]
            console.log(this.cashDeskToken)
            return this.cashDeskToken || this.$route.query.cash_desk_token
        },
        checkGoToCashModuleWithToken(idModule) {
            console.log(this.getCashDeskToken())
            return (
                this.checkGoToCashModule(idModule) &&
                this.getCashDeskToken() !== undefined
            )
        },
        showSnackBarError(error) {
            let snackInfo = null
            snackInfo = this.fillSnack('error', 'Error', error, false, 3000)
            this.initSnackbar(snackInfo)
        },
        checkGoToCashModule(idModule) {
            return idModule === this.CASH_MODULE_ID
        },
        checkDontGoToCashModule(idModule) {
            return !this.checkGoToCashModule(idModule)
        },
        handleTokenInput(e) {
            e.stopPropagation()
            e.preventDefault()
            let cashDeskModule = this.modules.find(m => m.id === 2)
            console.log(cashDeskModule)
            if (!cashDeskModule) return
            this.goToModule(cashDeskModule.url_module, cashDeskModule.id)
        },
    },
    watch: {
        cashDeskTokenModal(v) {
            if (v) this.$nextTick(() => this.$refs.cash_desk_token.focus())
        },
    },
}
</script>

<style lang="scss" scoped>
.main-content {
    overflow: auto;
}
.grid-area {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 20px;
}
.module-item {
    flex-direction: column;
    justify-content: space-between;
    cursor: pointer;
    &:hover {
        background-color: #eee;
    }
}
</style>
